<template>
  <div class="container">
    <!-- Modales -->
    <b-modal no-close-on-backdrop centered ref="entrega-documento-modal" title="" hide-footer id="modalC" size="xl">
      <div>
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(postDocumento)">
            <ModalEntregaDocumento
              accepted-file-types="application/pdf"
              :currentDocumento="currentDocumento"
              :cotejo="cotejo"
              @submit.prevent
            />
          </form>
        </ValidationObserver>
      </div>
    </b-modal>
    <b-modal no-close-on-backdrop centered ref="documento-modal-preview-img" title="" hide-footer id="modaldi" size="xl">
      <ModalPreviewImg :currentDocumento="currentDocumento" />
    </b-modal>
    <b-modal no-close-on-backdrop centered ref="documento-modal-preview-pdf" title="" hide-footer id="modaldf" size="xl">
      <ModalPreviewPDF :currentDocumento="currentDocumento" />
    </b-modal>
    <b-modal no-close-on-backdrop id="modal-more-info-2" size="xl" centered hide-footer>
      <div>
        <b-carousel id="carousel-cotejos-1" :interval="0" controls indicators background="#ababab">
          <b-carousel-slide :img-src="require('@/assets/img/cotejos/help/2_5.webp')"></b-carousel-slide>
        </b-carousel>
      </div>
    </b-modal>

    <!-- Template -->
    <h4 class="cardD">Entrega de Documentos</h4>

    <div class="row mb-3">
      <div class="col-md-12">
        <b-button variant="outline-primary" size="sm" @click="$bvModal.show('modal-more-info-2')">
          + Información tiempos de entrega
        </b-button>
      </div>
    </div>

    <div class="row mb-3" v-if="cotejo.eligio_llevar_documentos !== undefined">
      <div class="col-md-12">
        <h6 class="cardD">
          El cliente eligió llevar los documentos:
          <span :class="cotejo.eligio_llevar_documentos ? 'text-success' : 'text-danger'">
            {{ cotejo.eligio_llevar_documentos ? "Si" : "No" }}
          </span>
        </h6>
      </div>
    </div>

    <div>
      <b-table ref="table" hover :fields="fieldsDocumentos" :items="documentosToShow">
        <template #cell(descripcion)="{ item }">
          <div v-if="item.tipo === 'Otro'">
            <div v-b-tooltip.hover :title="item.descripcion">
              {{ item.tipo + " - " + item.descripcion }}
            </div>
          </div>
          <div v-else-if="item.tipo === 'Anexo'">
            {{ item.nombre }}
          </div>
          <div v-else>
            {{ item.tipo }}
          </div>
        </template>
        <template #cell(tipo)="{ item }">
          <div v-if="item.tipo === 'Otro'">
            <div v-b-tooltip.hover :title="item.descripcion">
              {{ item.tipo }}
            </div>
          </div>
          <div v-else>
            {{ item.tipo }}
          </div>
        </template>
        <template #cell(pdf_cliente)="{ item }">
          <div v-if="cotejo.eligio_llevar_documentos">
            N/A
            <b-button
              v-if="!item.documento && item.cat_documentos_id != 129"
              variant="success"
              size="sm"
              v-b-tooltip.hover
              title="Subir"
              @click="openEditDocumentoModal(item)"
              class="ml-2"
            >
              <b-icon-upload />
            </b-button>
          </div>
          <div v-else-if="!item.documento">
            <template v-if="item.cat_documentos_id != 129">
              Sin subir aún
              <b-button
                variant="success"
                size="sm"
                v-b-tooltip.hover
                title="Subir"
                @click="openEditDocumentoModal(item)"
                class="ml-2"
              >
                <b-icon-upload />
              </b-button>
            </template>
            <template v-else>No generado</template>
          </div>
          <div v-else>
            <b-button
              v-if="item.cat_documentos_id != 129"
              variant="success"
              size="sm"
              v-b-tooltip.hover
              title="Editar"
              @click="openEditDocumentoModal(item)"
              class="editBtn"
            >
              <b-icon-upload />
            </b-button>
            <b-button
              variant="primary"
              size="sm"
              v-b-tooltip.hover
              title="Vista previa"
              @click="previewDocumento(item)"
              class="editBtn"
            >
              <b-icon-eye />
            </b-button>
            <b-button size="sm" v-b-tooltip.hover title="Descargar" @click="descargarDocumento(item)" class="editBtn">
              <b-icon-download />
            </b-button>
          </div>
        </template>
        <template #cell(paginas_totales)="{ item }">
          <template v-if="item.cat_documentos_id != 129">
            {{ computePaginasTotales(item) }}
          </template>
        </template>
        <template #cell(precio_unitario)="{ item }">
          <template v-if="item.cat_documentos_id != 129">
            {{ formatCurrency(computePrecioUnitario(item)) }}
          </template>
        </template>
        <template #cell(costo_ok)="{ item }">
          <div v-if="item.cat_documentos_id != 129">
            <b-form-checkbox v-model="item.costo_ok" @change="updateDocumentoFlag(item)"></b-form-checkbox>
          </div>
        </template>
        <template #cell(mercantil_ok)="{ item }">
          <div v-if="item.cat_documentos_id != 129">
            <b-form-checkbox v-model="item.mercantil_ok" @change="updateDocumentoFlag(item)"></b-form-checkbox>
          </div>
        </template>
      </b-table>
    </div>

    <div v-if="datosCompletosKyc" ref="KycSolicitanteTemplate" hidden>
      <KycTemplate :id="cotejo.solicitante.id" :currentCompareciente="cotejo.solicitante" />
    </div>

    <div class="row mt-4">
      <div class="col-md-12">
        <p class="cardD" style="text-align: center">
          Validar los documentos únicamente si se cumplen los criterios del costo pagado y son documentos mercantiles.
        </p>
      </div>
    </div>

    <div class="d-flex mt-4">
      <div v-if="cotejo.staff">
        <b-button class="btn-fill btn-secondary mr-2" @click="generateKyc">Regenerar KYC</b-button>
      </div>

      <div class="ml-auto">
        <b-button type="button" class="btn-fill orange-btn" :disabled="isButtonDisabled" @click="$emit('allChecksPassed')">Validar</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import ModalPreviewImg from "@/views/clients/procesos/constitucion/entregadocumentos/ModalPreviewImg.vue";
import ModalPreviewPDF from "@/views/clients/procesos/constitucion/entregadocumentos/ModalPreviewPDF.vue";
import ModalEntregaDocumento from "@/views/clients/procesos/cotejo/infoBase/modales/ModalEntregaDocumento.vue";
import KycTemplate from "@/views/staff/tasks/validaciones/constitucionsociedades/KycTemplate.vue";

import { DocumentosApi, FuncionesApi } from "@/api";
import loadingMixin from "@/mixins/loadingMixin";
import { formatCurrency } from "@/utils/number-utils";

export default {
  name: "EntregaDocumentos",

  components: {
    ModalEntregaDocumento,
    ModalPreviewImg,
    ModalPreviewPDF,
    KycTemplate,
  },

  mixins: [loadingMixin],

  props: {
    cotejo: { type: Object },
  },

  computed: {
    fieldsDocumentos() {
      return [
        { key: "descripcion", label: "Descripción", class: "text-center" },
        { key: "paginas_totales", label: "Páginas", class: "text-center" },
        { key: "precio_unitario", label: "$ Unitario", class: "text-center" },
        { key: "pdf_cliente", label: "PDF Cliente", class: "text-center" },
        { key: "costo_ok", label: "Costo Ok", class: "text-center" },
        { key: "mercantil_ok", label: "Mercantil Ok", class: "text-center" },
      ];
    },

    isButtonDisabled() {
      if (this.cotejo.eligio_llevar_documentos) {
        return false;
      }

      const allowedIds = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 29];
      const docsToCheck = this.documentosToShow.filter((doc) =>
        allowedIds.includes(Number(doc.cat_documentos_id)),
      );

      const result = !docsToCheck.every((doc) => doc.costo_ok && doc.mercantil_ok);

      return result;
    },
  },

  created() {
    this.toggleOnLoading();
    this.selectDocumentosToShow()
      .then(() => this.areDocumentosCompletos())
      .then(() => this.checkDocsUploaded())
      .then(() => this.refreshTable())
      .catch((error) => {
        this.showErrorToast("No se pudieron cargar los documentos. Intente más tarde.");
        console.log(error);
      })
      .finally(this.toggleOffLoading);
  },

  data() {
    return {
      datosCompletosKyc: false,

      documentosToShow: [],
      documentosCompletos: false,
      confirmAceptacion: false,

      currentDocumento: {},

      htmlStyles:
        "<style>.maps{text-align:center;vertical-align:middle}.new-page{break-before:page}.logo{width:auto;height:100px;float:right}.tabla{width:100%;font-size:15px;font-family:Arial,Helvetica,sans-serif;border-collapse:separate;border-spacing:0 1em}.section{background-color:#4bacc6;color:#fff;text-align:center;height:40px;font-weight:bolder}.section-empty{text-align:center;font-weight:bolder;font-size:18px}.firstline{border:5px solid #fff}.title{font-size:12px;text-align:left;width:20%;font-weight:700}.select{text-align:left;width:5%}.circle{border-radius:100%;height:15px;width:15px;border:2px solid #4bacc6;margin-bottom:0}.filledcircle{border-radius:100%;height:15px;width:15px;border:2px solid #4bacc6;background-color:#4bacc6;margin-bottom:0}.verifycheck{border:2px solid #4bacc6;background-color:#e7eef5;text-align:center}.right-title{font-size:12px;text-align:right;font-weight:700}.user{text-align:left;font-size:12px;font-weight:lighter;border-bottom:solid 1px #000;background-color:#e7eef5}.leyenda{font-size:9px}</style>",
    };
  },

  methods: {
    showErrorToast(msg) {
      this.$toast.error(msg, {
        timeout: 4000, //false,
        hideProgressBar: false,
        position: "top-right",
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        closeButton: "button",
        icon: true,
      });
    },

    async selectDocumentosToShow() {
      const cat_documentos_id_to_include = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 29];

      if (this.cotejo.staff) {
        cat_documentos_id_to_include.push(129);
      }

      const docs = this.cotejo.documentos.filter(
        (doc) => cat_documentos_id_to_include.includes(Number(doc.cat_documentos_id)) && doc.numero_documento !== 2,
      );

      const kycDocs = docs.filter((doc) => Number(doc.cat_documentos_id) === 129);
      const nonKycDocs = docs.filter((doc) => Number(doc.cat_documentos_id) !== 129);

      this.documentosToShow = [...nonKycDocs, ...kycDocs];
    },

    async checkDocsUploaded() {
      this.documentosToShow.forEach((doc) => {
        doc.tieneDocumento = doc.documento ? "✔" : "X";
      });
    },

    openEditDocumentoModal(documento) {
      this.$refs["entrega-documento-modal"].show();
      this.currentDocumento = documento;
    },

    hideEditDocumentoModal() {
      this.$refs["entrega-documento-modal"].hide();
    },

    postDocumento() {
      this.hideEditDocumentoModal();
      this.sendCurrentDocumentoToAzureStorage();
    },

    async sendCurrentDocumentoToAzureStorage() {
      try {
        this.toggleOnLoading();

        this.currentDocumento.nombre = this.currentDocumento.file.name;

        const formData = new FormData();
        formData.append("file", this.currentDocumento.file);
        const path = await FuncionesApi.file(this.cotejo.id, "documentosCotejos", formData, {});

        this.currentDocumento.documento = path;
        this.currentDocumento.tieneDocumento = "✔";
        this.updateDocumentoBD();
      } catch (error) {
        this.showErrorToast("Error al mandar el archivo. Intente más tarde.");
        console.log(error);
      } finally {
        this.toggleOffLoading();
      }
    },

    async updateDocumentoBD() {
      try {
        this.toggleOnLoading();

        await DocumentosApi.edit(this.currentDocumento.id, {
          documento: this.currentDocumento.documento,
          cat_documentos_id: this.currentDocumento.cat_documentos_id,
          auto_referencia: this.currentDocumento.auto_referencia,
          descripcion: this.currentDocumento.descripcion,
          paginas: parseInt(this.currentDocumento.paginas),
          copias_certificadas: parseInt(this.currentDocumento.copias_certificadas),
          nombre: this.currentDocumento.nombre,
          activo: 1,
        });
        this.updatecotejoDocumentoFromCurrentDocumento();
      } catch (error) {
        this.showErrorToast("Error al actualizar el documento. Intente más tarde.");
        console.log(error);
      } finally {
        this.toggleOffLoading();
      }
    },

    updatecotejoDocumentoFromCurrentDocumento() {
      const cotejoDocumentosIndex = this.getcotejoDocumentosIndex(this.currentDocumento);
      this.documentosToShow[cotejoDocumentosIndex] = this.currentDocumento;
      this.documentosToShow[cotejoDocumentosIndex].tieneDocumento = "✔";
      this.areDocumentosCompletos();
    },

    getcotejoDocumentosIndex(documento) {
      return this.documentosToShow.findIndex((d) => d.id === Number(documento.id));
    },

    previewDocumento(item) {
      this.currentDocumento = item;

      const refName = this.isCurrentDocumentAnImage() ? "documento-modal-preview-img" : "documento-modal-preview-pdf";

      this.$refs[refName].show();
    },

    isCurrentDocumentAnImage() {
      const extension = this.currentDocumento.nombre.split(".").pop().toLowerCase();
      const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg", "tiff", "avif"];

      return imageExtensions.includes(extension);
    },

    areDocumentosCompletos() {
      let completos = true;

      if (this.documentosToShow.length == 0) {
        return;
      }
      this.documentosToShow.forEach((documento) => {
        if (documento.documento == "") {
          completos = false;
        }
      });

      this.documentosCompletos = completos;
      this.refreshTable();
    },

    refreshTable() {
      this.$refs.table.refresh();
    },

    formatCurrency,

    async updateDocumentoFlag(item) {
      try {
        this.toggleOnLoading();
        await DocumentosApi.edit(item.id, {
          ...item,
        });
        this.$toast.success("Documento actualizado correctamente", {
          timeout: 3000,
          position: "top-right",
          icon: true,
        });
      } catch (error) {
        this.showErrorToast("Error al actualizar el documento. Intente más tarde.");
        console.log(error);
      } finally {
        this.toggleOffLoading();
      }
    },

    computePaginasTotales(item) {
      if (![1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 29].includes(Number(item.cat_documentos_id))) return 0;
      let total = parseInt(item.paginas) || 0;
      if (!this.cotejo || !this.cotejo.documentos) return total;

      const anexos = this.cotejo.documentos.filter(
        (doc) => Number(doc.cat_documentos_id) === 73 && doc.auto_referencia === item.id,
      );
      anexos.forEach((anexo) => {
        total += parseInt(anexo.paginas) || 0;
      });
      return total;
    },

    computePrecioUnitario(item) {
      if (![1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 29].includes(Number(item.cat_documentos_id))) return 0;
      if (!this.cotejo?.cotizacion?.conceptos) return 0;
      let conceptos = this.cotejo.cotizacion.conceptos;
      if (typeof conceptos === "string") {
        try {
          conceptos = JSON.parse(conceptos);
        } catch (e) {}
      }

      let pagina_util = parseFloat(conceptos.precio_pagina_util || conceptos.precio_pagina_util || 0);
      let monto_base = parseFloat(conceptos.monto_base || conceptos.precio_monto_base || 0);
      const paginas_totales = this.computePaginasTotales(item);

      return paginas_totales * pagina_util + monto_base;
    },

    async generateKyc() {
      try {
        this.toggleOnLoading();
        this.datosCompletosKyc = true;
        await this.$nextTick();

        const el = this.$refs["KycSolicitanteTemplate"];
        if (!el) {
          // TODO handle this
          return;
        }

        const html = el.innerHTML;
        const fullHtml =
          '<!DOCTYPE html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1.0">' +
          `${this.htmlStyles}</head><body>${html.replace(/data-v-[a-z0-9]*=""/g, "")}</body></html>`;
        const buffer = Buffer.from(fullHtml);
        const buffer_str = buffer.toString("base64");
        const comparecientes_d = [
          {
            comparecientes_id: this.cotejo.solicitante.id,
            html: buffer_str,
          },
        ];

        const documentos_kycs = await FuncionesApi.generaKyc({
          proceso_id: this.cotejo.id,
          cat_servicios_id: 4,
          html: "kyc",
          comparecientes: comparecientes_d,
        });
      } catch (error) {
        console.log(error);
        this.showErrorToast("Ocurrió un error al generar el KYC. Intente más tarde.");
      } finally {
        this.toggleOffLoading();
      }
    },

    async descargarDocumento(documento) {
      try {
        this.toggleOnLoading();

        const response = await FuncionesApi.descargarDocumento(documento.id);
        const filename = documento.documento.split("/").pop();

        saveAs(response, filename);
      } catch (error) {
        console.error("Error downloading file:", error);
        this.showErrorToast("Error al descargar el archivo.");
      } finally {
        this.toggleOffLoading();
      }
    },
  },
};
</script>
